var render = function render(){var _vm=this,_c=_vm._self._c;return _c('q-page',{staticClass:"flex column login page-layout"},[_c('PageTitle',{attrs:{"title":'Profile',"parentPage":'Profile',"icon":'face'}}),_c('div',{staticClass:"q-py-lg row items-start q-gutter-md"},[_c('q-card',{staticClass:"content-card q-pa-md",attrs:{"flat":""}},[_c('q-card-section',[_vm._v("Email: "+_vm._s(_vm.email)+" ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }